<template>
    <div class="sitemap nunito">
      <h1>Mapa del Sitio</h1>
      <div class="content">
        <ul>
          <li><router-link to="/">Inicio</router-link></li>
          <li><router-link to="/about">Nosotros</router-link></li>
          <li><router-link to="/services">Servicios</router-link></li>
          <li><router-link to="/contact">Contacto</router-link></li>
          <li><router-link to="/blogs">Blogs</router-link></li>
          <li><router-link to="/terms-of-service">Términos de Servicio</router-link></li>
          <li><router-link to="/privacy-policy">Política de Privacidad</router-link></li>
          <li><router-link to="/faqs">Preguntas Frecuentes</router-link></li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SitemapComponent',
  };
  </script>
  
  <style lang="scss" scoped>
  .sitemap {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    line-height: 1.6;
  
    h1 {
      text-align: center;
      margin-bottom: 20px;
      font-size: 2.5rem;
    }
  
    .content {
      ul {
        list-style: none;
        padding: 0;
  
        li {
          margin-bottom: 10px;
  
          a {
            text-decoration: none;
            color: #007bff;
            font-size: 1.25rem;
  
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  </style>
  